import { Form, Row, Col, Dropdown} from 'react-bootstrap'
import { KYC_STATUSES, KYC_SELECT_STATUSES} from '../constants'

const KYCDropdownStatus = ({ status, setStatus }) => {
  return (
    <Form>
      <Row>
        <b style={{ marginTop: '16px', marginLeft: '20px' }}>สถานะการตรวจสอบ:</b>
        <Col sm={12} md={6} lg={4}>
          <Dropdown>
            <select
              className="form-control"
              style={{ color: '#5d5d5d' }}
              onChange={(value) => {
                setStatus(value.target.value)
              }}
              value={status}
              defaultValue={KYC_STATUSES.PENDING}
            >
              {KYC_SELECT_STATUSES.map((status, i) => {
                return (
                  <option key={i} value={status.value}>
                    {status.label}
                  </option>
                )
              })}
            </select>
          </Dropdown>
        </Col>
      </Row>
    </Form>
  )
}

export default KYCDropdownStatus
